import React, { useEffect, useState } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import Link from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import Button from '@material-ui/core/Button'
import { AiOutlineMessage, AiOutlineArrowRight } from 'react-icons/ai'
import PortfolioFrame from '../components/PortfolioFrame'
import ListArticle from '../components/ListArticle'
import ButtonMore from '../components/ButtonMore'
import dataBlog from '../utils/blog-handler/dataBlog'
import scrolls from 'scrolls.js'
import { styleGoalGridContainer, styleSpan } from './styles'

const HeaderOfListArticle = () => {
	return (
		<React.Fragment >
			<Grid item container justifyContent="center" xs={12}>
	            <Typography variant="h4" align="center">Blog</Typography>
	        </Grid>
	        <Grid item container justifyContent="center">
	            <Link component={RouterLink} to="/projects" color="inherit">
	                Ver proyectos{' '}
	                <IconButton 
	                    className="icon-button" 
	                    title="Proyectos" 
	                    color="inherit"
	                    style={{ 
	                    	background: "#d3d3d320",
	                    	fontSize: '14px'
	            	 	}}
	                    >
	                    <AiOutlineArrowRight />
	                </IconButton>
	            </Link>
	        </Grid>
        </React.Fragment>
	)
}

const BlogPage = () => {
	const longDefault = 6;
	const LONG_NAME = "longListArticle"
	const [long, setLong] = useState(longDefault);

	useEffect(() => {
		const longLocalStorage = localStorage.getItem(LONG_NAME);

		if (longLocalStorage) {
			setLong(longLocalStorage);
			return;
		}
	}, [])

	useEffect(() => {
		const scrollY = localStorage.getItem('scrollY');

		if (!scrollY || scrollY==='0') {
			window.scroll(0, 0)
			return
		}

		scrolls(Number.parseInt(scrollY))
		return () => {
			localStorage.removeItem('scrollY')
		}
	}, [])

	return (
		<PortfolioFrame>
			<Grid item container justifyContent='center' style={{color: '#fff', padding: '20px 0 20px 0'}}>
                <HeaderOfListArticle />
                <Grid item container justifyContent='center' xs={12} style={styleGoalGridContainer}>
					<Grid 
						item container 
						direction='column' 
						alignItems='center' 
						xs={11} sm={10}
					>
			            <Typography align='center' style={{fontSize: '18px'}}>
			            	El objetivo de 
			            		<span style={styleSpan}>
			            			{' '}Blog{' '}
			            		</span> 
			            	es guardar las soluciones que casi siempre necesito.
		            	</Typography>
		        	</Grid>
                </Grid>

                {/*Initial long está arriba en un useEffect*/}
				<ListArticle data={dataBlog} long={long} />
				<ButtonMore
					longName={LONG_NAME}
					longDefault={longDefault} 
					long={long} 
					setLong={setLong} 
				/>
				<HeaderOfListArticle />
			</Grid>
		</PortfolioFrame>
	)
}

export default BlogPage